import { cartLineCardExpandedStyles } from "@insite/content-library/Components/CartLineCardExpanded";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

cartLineCardExpandedStyles.priceGridItem = {
    width: [12, 12, 5, 5, 5],
    printWidth: 5,
    css: css`
        flex-direction: column;
        > section {
            > div[class^="sc"] {
                > div[class^="sc"] {
                    padding: 0;
                    > span {
                        display: none;
                    }
                    h4 {
                        padding: 0px 2px;
                        font-size: 14px !important;
                        line-height: 24px;
                        span {
                            display: block;
                            margin-left: 0px !important;
                        }
                    }
                }
            }
            > span {
                display: none;
            }
        }

        ${({ theme }: { theme: BaseTheme }) =>
        breakpointMediaQueries(theme, [
            css`
                > section {
                    > div[class^="sc"] {
                        > div[class^="sc"] {
                            > span {
                            }
                            h4 {
                                font-size: 14px !important;
                                span {
                                    display: unset;
                                    margin-left: 8px !important;
                                }
                            }
                        }
                    }
                    > span {
                        display: none;
                    }
                }
            `,
            css`
                > section {
                    > div[class^="sc"] {
                        > div[class^="sc"] {
                            > span {
                            }
                            h4 {
                                span {
                                    display: unset;
                                    margin-left: 8px !important;
                                }
                            }
                        }
                    }
                    > span {
                        display: none;
                    }
                }
            `,
            css`
                > section {
                    > div[class^="sc"] {
                        > div[class^="sc"] {
                            > span {
                            }
                            h4 {
                                span {
                                    display: unset;
                                    margin-left: 8px !important;
                                }
                            }
                        }
                    }
                    > span {
                        display: none;
                    }
                }
            `,
            null,
            null,
        ])}
    `,
};
